export const RECOMMENDATION_THUMBNAIL_COLORS = [
  '#D5CDE0',
  '#CDDEE8',
  '#E5D7D5',
  '#CDE0D0',
  '#E6E1C6',
  '#C8D3EF',
];

export const RECOMMENDATIONS_PREVIEW_CAROUSEL_ID =
  'recommendations-preview-carousel';
